import React from 'react';
import GoHome from '../../assets/GoHome.png';
import network from '../../info/network.js';
import styles from './Footer.module.css';

const Footer = () => {
     return (
          <div id="footer" className={styles.container}>
               <div className={styles.button_container}>
                    <div className={styles.button}>
                         <div className={styles.button_wrapper}>
                              <a href="#header">
                                   <div className={styles.text_gohome}>
                                        <img src={GoHome} alt="goHome" style={{ width: '50%' }} />
                                   </div>
                                   <span className={styles.icon_gohome}>
                                        <img src={GoHome} alt="goHome" style={{ width: '50%' }} />
                                   </span>
                              </a>
                         </div>
                    </div>
               </div>
               <div className={styles.networks_container}>
                    <div className={styles.networks}>
                         {network.map((data) => {
                              return (
                                   <div key={data.link} className={styles.network_button_container}>
                                        <div className={styles.network_button}>
                                             <div className={styles.button_wrapper}>
                                                  <a
                                                       href={data.link}
                                                       target="_blank"
                                                       rel="noreferrer"
                                                  >
                                                       <div className={styles.goNetwork}>
                                                            <img
                                                                 src={data.img}
                                                                 alt={data.name}
                                                                 style={{ width: '50%' }}
                                                            />
                                                       </div>
                                                       <span className={styles.icon_goNetwork}>
                                                            <img
                                                                 src={data.img}
                                                                 alt={data.name}
                                                                 style={{ width: '50%' }}
                                                            />
                                                       </span>
                                                  </a>
                                             </div>
                                        </div>
                                   </div>
                              );
                         })}
                    </div>
                    <p>
                         AGUSTIN OJEDA <span className={styles.date}>©2022</span>
                    </p>
               </div>
          </div>
     );
};

export default Footer;
